"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "title", "buttonTexts", "toggleButtonText", "setToggleButtonText", "onToggleButtonClick", "disableButton", "icon", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".TogglePanel {\n  color: #424242;\n  position: relative;\n  border: 1px solid #ededed;\n}\n.TogglePanel.no_header {\n  border: none;\n}\n.TogglePanel--header {\n  background-color: #ededed;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n}\n.TogglePanel--header--title {\n  margin-bottom: 0;\n}\n.TogglePanel--header--button_wrapper {\n  display: flex;\n  justify-content: end;\n}\n.TogglePanel--header--button {\n  text-decoration: underline !important;\n  border: none;\n  margin: 0;\n  padding: 0 !important;\n}\n.TogglePanel--header--button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.TogglePanel--body {\n  padding: 1rem;\n  background: #ffffff;\n}\n.TogglePanel--body.no_header {\n  padding: 0;\n}\n.TogglePanel--body--button {\n  text-decoration: underline !important;\n  border: none;\n  margin: 0;\n  padding: 0 !important;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.TogglePanel--body--button:disabled {\n  opacity: 0.5;\n  cursor: pointer;\n}\n.TogglePanel__icon {\n  width: 1.5rem;\n}";
  var fileName = "TogglePanel_TogglePanel";
  var element = document.querySelector("style[data-sass-component='TogglePanel_TogglePanel']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var TogglePanel = function TogglePanel(_ref) {
  var _buttonTexts$, _buttonTexts$2;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$buttonTexts = _ref.buttonTexts,
    buttonTexts = _ref$buttonTexts === void 0 ? null : _ref$buttonTexts,
    _ref$toggleButtonText = _ref.toggleButtonText,
    toggleButtonText = _ref$toggleButtonText === void 0 ? false : _ref$toggleButtonText,
    _ref$setToggleButtonT = _ref.setToggleButtonText,
    setToggleButtonText = _ref$setToggleButtonT === void 0 ? function () {} : _ref$setToggleButtonT,
    _ref$onToggleButtonCl = _ref.onToggleButtonClick,
    onToggleButtonClick = _ref$onToggleButtonCl === void 0 ? null : _ref$onToggleButtonCl,
    _ref$disableButton = _ref.disableButton,
    disableButton = _ref$disableButton === void 0 ? false : _ref$disableButton,
    icon = _ref.icon,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var text = buttonTexts ? !toggleButtonText ? (_buttonTexts$ = buttonTexts[0]) == null ? void 0 : _buttonTexts$.toUpperCase() : (_buttonTexts$2 = buttonTexts[1]) == null ? void 0 : _buttonTexts$2.toUpperCase() : null;
  var newButtonProps = {
    size: 'medium',
    variant: 'link',
    children: text,
    disabled: disableButton,
    'aria-disabled': disableButton,
    onClick: function onClick() {
      if (onToggleButtonClick) {
        onToggleButtonClick(!toggleButtonText);
      }
      setToggleButtonText(!toggleButtonText);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: "TogglePanel ".concat(className, " ").concat(!title ? 'no_header' : '')
  }, rest), {}, {
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "TogglePanel--header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "TogglePanel--header--title",
        children: title.toUpperCase()
      }), buttonTexts && buttonTexts.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], _objectSpread({
        className: "TogglePanel--header--button"
      }, newButtonProps)), icon && !toggleButtonText && !(buttonTexts && buttonTexts.length > 0) && (typeof icon === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
        size: "utility",
        src: icon
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "TogglePanel__icon",
        children: icon
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "TogglePanel--body  ".concat(!title ? 'no_header' : ''),
      children: [children, !title && buttonTexts && buttonTexts.length === 2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], _objectSpread({
        className: "TogglePanel--body--button"
      }, newButtonProps))]
    })]
  }));
};
var _default = TogglePanel;
exports["default"] = _default;